<template>
    <div class="" style="padding: 0;height: 100%;width: 90%;">
        <div class="" id="righthomeCenter" @mouseenter="clearDispatchTimer" @mouseleave="setDispatchTimer"
            style="height: 100%;width: 100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-gl'
export default {
    data() {
        return {
            interVal: '',
            myChart: null,
            app: {
                currentIndex: -1,
            },
            dispatchTimer: null,
            dataLen: null
        }
    },
    mounted() {
        // this.requestData(500)
        this.init()
    },
    methods: {
        requestData(number, area, tulongNum, beforeMoney, afterMoney) {
            this.$request('center/newService1/farmLines?num=' + number + '&area=' + area + '&tulongNum=' + tulongNum + '&beforeMoney=' + beforeMoney + '&afterMoney=' + afterMoney).then(res => {
                if (this.myChart) {
                    clearInterval(this.dispatchTimer)
                    this.myChart.clear()
                }
                for (var i = 0; i < res.data.length; i++) {
                    if (res.data[i].type == 1) {
                        this.init(res.data[i].list);
                    }
                }

            })
        },
        init(pageData, type) {
            let that = this
            that.myChart = echarts.init(document.getElementById('righthomeCenter'))

            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                that.myChart.resize();
            });

            // let xaxisData = ['2023年', '2024年', '2025年']
            // let yaxisData = [256, 299, 110]
            // let yaxisData2 = [2467, 2547, 1963]
            // let yaxisData3 = [3489, 3324, 2106]
            // let yaxisData4 = [309, 290, 232]
			
			let xaxisData = ['2025年','2026年']
			let yaxisData = [ 230.88,46.43]
			let yaxisData2 = [117.6,35.5]
			let yaxisData3 = [ 2106]
			let yaxisData4 = [ 232]
			
            const offsetX = 8;
            const offsetY = 4;
            // 绘制左侧面
            const CubeLeft = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    // 会canvas的应该都能看得懂，shape是从custom传入的
                    const xAxisPoint = shape.xAxisPoint;
                    const c0 = [shape.x, shape.y];
                    const c1 = [shape.x - offsetX, shape.y - offsetY];
                    const c2 = [xAxisPoint[0] - offsetX, xAxisPoint[1] - offsetY];
                    const c3 = [xAxisPoint[0], xAxisPoint[1]];
                    ctx
                        .moveTo(c0[0], c0[1])
                        .lineTo(c1[0], c1[1])
                        .lineTo(c2[0], c2[1])
                        .lineTo(c3[0], c3[1])
                        .closePath();
                },
            });

            // 绘制右侧面
            const CubeRight = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    const xAxisPoint = shape.xAxisPoint;
                    const c1 = [shape.x, shape.y];
                    const c2 = [xAxisPoint[0], xAxisPoint[1]];
                    const c3 = [xAxisPoint[0] + offsetX, xAxisPoint[1] - offsetY];
                    const c4 = [shape.x + offsetX, shape.y - offsetY];
                    ctx
                        .moveTo(c1[0], c1[1])
                        .lineTo(c2[0], c2[1])
                        .lineTo(c3[0], c3[1])
                        .lineTo(c4[0], c4[1])
                        .closePath();
                },
            });

            // 绘制顶面
            const CubeTop = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    const c1 = [shape.x, shape.y];
                    const c2 = [shape.x + offsetX, shape.y - offsetY]; //右点
                    const c3 = [shape.x, shape.y - offsetX];
                    const c4 = [shape.x - offsetX, shape.y - offsetY];
                    ctx
                        .moveTo(c1[0], c1[1])
                        .lineTo(c2[0], c2[1])
                        .lineTo(c3[0], c3[1])
                        .lineTo(c4[0], c4[1])
                        .closePath();
                },
            });

            // 注册三个面图形
            echarts.graphic.registerShape("CubeLeft", CubeLeft);
            echarts.graphic.registerShape("CubeRight", CubeRight);
            echarts.graphic.registerShape("CubeTop", CubeTop);

            var option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                    backgroundColor: '#001127',
                    extraCssText: "box-shadow: 2px 2px 4px 0px rgba(0,0,0,0.3);",
                    textStyle: {
                        fontSize: 14,
                        color: "#fff",
                    },
                    formatter: (params, ticket, callback) => {
                        const item = params[1];
                        let da = ''
                        for (let i = 0; i < params.length; i++) {
                            if (params[i].seriesType == 'custom') {
                                if(params[i].seriesName == '总用水量'){
                                    da += params[i].seriesName + ':' + params[i].value + '万m³ <br/>'
                                }else if(params[i].seriesName == '物资耗费金额'){
                                    da += params[i].seriesName + ':' + params[i].value + '万元 <br/>'
                                }else{
                                    da += params[i].seriesName + ':' + params[i].value + '吨 <br/>'
                                }
                            }
                        }
                        return item.name + " <br/> " + da;
                    },
                },
                grid: {
                    left: "1%",
                    right: "0%",
                    top: "20%",
                    bottom: "0%",
                    containLabel: true,
                },
                "legend":
                {
                    data: [{
                        name: '总用水量',
                        itemStyle: {
                            color: '#29adff'
                        }
                    }, {
                        name: '总用肥量',
                        itemStyle: {
                            color: '#00FF57'
                        }
                    }, {
                        name: '总用药量',
                        itemStyle: {
                            color: 'rgb(238, 241, 23)'
                        }
                    }, {
                        name: '物资耗费金额',
                        itemStyle: {
                            color: '#907EFF'
                        }
                    }],
                    "show": true,
                    "top": 5,
                    "right": 0,
                    "itemWidth": 14,
                    "itemHeight": 14,
                    "icon": "react",
                    "textStyle":
                    {
                        "fontSize": 15,
                        "color": "#AEC6DF"
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xaxisData,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            width: 1,
                            color: '#FFFFFF'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 14,
                        color: '#FFFFFF'
                    }
                },
                yAxis: {
                    type: 'value',
                    "splitNumber": 4,
                    nameTextStyle: {
                        color: '#fff',
                        fontWeight: 400,
                        fontSize: 14
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            width: 1,
                            color: '#545454'
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 14,
                        color: '#FFFFFF'
                    }
                },
                series: [
                    {
                        name: '总用水量',
                        type: "custom",
                        renderItem: (params, api) => {
                            const location = api.coord([api.value(0), api.value(1)]);
                            const xAxisPoint = api.coord([api.value(0), 0]);
                            const distance = 30;
                            return {
                                type: "group",
                                children: [
                                    {
                                        type: "CubeLeft",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0] - distance,
                                            y: location[1],
                                            xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                                        },
                                        style: {
                                            fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {
                                                    offset: 0,
                                                    color: '#0094FF',
                                                },
                                                {
                                                    offset: 0.35,
                                                    color: '#3CB9FF'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'transparent'
                                                }
                                            ]),
                                        },
                                    },
                                    {
                                        type: "CubeRight",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0] - distance,
                                            y: location[1],
                                            xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                                        },
                                        style: {
                                            fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {
                                                    offset: 0,
                                                    color: '#0094FF',
                                                },
                                                {
                                                    offset: 0.35,
                                                    color: '#25A1FF'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'transparent'
                                                }
                                            ]),
                                        },
                                    },
                                    {
                                        type: "CubeTop",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0] - distance,
                                            y: location[1],
                                            xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                                        },
                                        style: {
                                            fill: '#0084FF'
                                        },
                                    },
                                ],
                            };
                        },
                        data: yaxisData2,
                    },
                    {
                        type: "custom",
                        name: '总用肥量',
                        renderItem: (params, api) => {
                            const location = api.coord([api.value(0), api.value(1)]);
                            const xAxisPoint = api.coord([api.value(0), 0]);
                            const distance = 12;
                            return {
                                type: "group",
                                children: [
                                    {
                                        type: "CubeLeft",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0] - distance,
                                            y: location[1],
                                            xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                                        },
                                        style: {
                                            fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {
                                                    offset: 0,
                                                    color: '#00FF57',
                                                },
                                                {
                                                    offset: 0.35,
                                                    color: '#00DD58'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'transparent'
                                                }
                                            ]),
                                        },
                                    },
                                    {
                                        type: "CubeRight",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0] - distance,
                                            y: location[1],
                                            xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                                        },
                                        style: {
                                            fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {
                                                    offset: 0,
                                                    color: '#01DE4C',
                                                },
                                                {
                                                    offset: 0.35,
                                                    color: '#00BC62'
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'transparent'
                                                }
                                            ]),
                                        },
                                    },
                                    {
                                        type: "CubeTop",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0] - distance,
                                            y: location[1],
                                            xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                                        },
                                        style: {
                                            fill: '#007E33'
                                        },
                                    },
                                ],
                            };
                        },
                        data: yaxisData,
                    },
                    // {
                    //     type: "custom",
                    //     name: '总用药量',
                    //     renderItem: (params, api) => {
                    //         const location = api.coord([api.value(0), api.value(1)]);
                    //         const xAxisPoint = api.coord([api.value(0), 0]);
                    //         const distance = -6;
                    //         return {
                    //             type: "group",
                    //             children: [
                    //                 {
                    //                     type: "CubeLeft",
                    //                     shape: {
                    //                         api,
                    //                         xValue: api.value(0),
                    //                         yValue: api.value(1),
                    //                         x: location[0] - distance,
                    //                         y: location[1],
                    //                         xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                    //                     },
                    //                     style: {
                    //                         fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //                             {
                    //                                 offset: 0,
                    //                                 color: '#FCFF7E',
                    //                             },
                    //                             {
                    //                                 offset: 0.35,
                    //                                 color: '#EEDB2D'
                    //                             },
                    //                             {
                    //                                 offset: 1,
                    //                                 color: 'transparent'
                    //                             }
                    //                         ]),
                    //                     },
                    //                 },
                    //                 {
                    //                     type: "CubeRight",
                    //                     shape: {
                    //                         api,
                    //                         xValue: api.value(0),
                    //                         yValue: api.value(1),
                    //                         x: location[0] - distance,
                    //                         y: location[1],
                    //                         xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                    //                     },
                    //                     style: {
                    //                         fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //                             {
                    //                                 offset: 0,
                    //                                 color: '#FFF06D',
                    //                             },
                    //                             {
                    //                                 offset: 0.35,
                    //                                 color: '#FFEB3A'
                    //                             },
                    //                             {
                    //                                 offset: 1,
                    //                                 color: 'transparent'
                    //                             }
                    //                         ]),
                    //                     },
                    //                 },
                    //                 {
                    //                     type: "CubeTop",
                    //                     shape: {
                    //                         api,
                    //                         xValue: api.value(0),
                    //                         yValue: api.value(1),
                    //                         x: location[0] - distance,
                    //                         y: location[1],
                    //                         xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                    //                     },
                    //                     style: {
                    //                         fill: '#ECF031'
                    //                     },
                    //                 },
                    //             ],
                    //         };
                    //     },
                    //     data: yaxisData3,
                    // },
                    // {
                    //     type: "custom",
                    //     name: '物资耗费金额',
                    //     renderItem: (params, api) => {
                    //         const location = api.coord([api.value(0), api.value(1)]);
                    //         const xAxisPoint = api.coord([api.value(0), 0]);
                    //         const distance = -24;
                    //         return {
                    //             type: "group",
                    //             children: [
                    //                 {
                    //                     type: "CubeLeft",
                    //                     shape: {
                    //                         api,
                    //                         xValue: api.value(0),
                    //                         yValue: api.value(1),
                    //                         x: location[0] - distance,
                    //                         y: location[1],
                    //                         xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                    //                     },
                    //                     style: {
                    //                         fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //                             {
                    //                                 offset: 0,
                    //                                 color: '#907EFF',
                    //                             },
                    //                             {
                    //                                 offset: 0.35,
                    //                                 color: '#7B65FF'
                    //                             },
                    //                             {
                    //                                 offset: 1,
                    //                                 color: 'transparent'
                    //                             }
                    //                         ]),
                    //                     },
                    //                 },
                    //                 {
                    //                     type: "CubeRight",
                    //                     shape: {
                    //                         api,
                    //                         xValue: api.value(0),
                    //                         yValue: api.value(1),
                    //                         x: location[0] - distance,
                    //                         y: location[1],
                    //                         xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                    //                     },
                    //                     style: {
                    //                         fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //                             {
                    //                                 offset: 0,
                    //                                 color: '#826DFF',
                    //                             },
                    //                             {
                    //                                 offset: 0.35,
                    //                                 color: '#6E3AFF'
                    //                             },
                    //                             {
                    //                                 offset: 1,
                    //                                 color: 'transparent'
                    //                             }
                    //                         ]),
                    //                     },
                    //                 },
                    //                 {
                    //                     type: "CubeTop",
                    //                     shape: {
                    //                         api,
                    //                         xValue: api.value(0),
                    //                         yValue: api.value(1),
                    //                         x: location[0] - distance,
                    //                         y: location[1],
                    //                         xAxisPoint: [xAxisPoint[0] - distance, xAxisPoint[1]],
                    //                     },
                    //                     style: {
                    //                         fill: '#5A25F0'
                    //                     },
                    //                 },
                    //             ],
                    //         };
                    //     },
                    //     data: yaxisData4,
                    // },
                    {
                        type: "bar",
                        itemStyle: {
                            color: "transparent",
                        },
                        data: yaxisData,
                    },
                ],
            };




            that.dataLen = option.series[0].data.length
            that.dispatchActions()

            that.myChart.setOption(option);
            this.interVal = setInterval(function () {
                that.myChart.clear()
                that.myChart.setOption(option);
            }, 240000)
            // 20000
        },
        dispatchActions() {
            let that = this
            that.dispatchTimer = setInterval(function () {
                // 取消之前高亮的图形
                that.myChart.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex
                });
                that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
                // 高亮当前图形
                that.myChart.dispatchAction({
                    type: 'highlight',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex,
                });
                // 显示 tooltip
                that.myChart.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex
                });
            }, 3000);
        },
        clearDispatchTimer() {
            clearInterval(this.dispatchTimer)
        },
        setDispatchTimer() {
            this.dispatchActions()
        },
    },
    destroyed() {
        clearInterval(this.interVal)
    },

}
</script>

<style>
.a {
    /* color: #fff; */
}


</style>